import 'react-dates/initialize'

import type { DatePickerProps } from './DatePicker'
import DatePicker from './DatePicker'
import {
  renderCustomCloseIcon,
  renderCustomInputIcon,
  renderNavNextButton,
  renderNavPrevButton,
} from './datePickerIcons'

import 'react-dates/lib/css/_datepicker.css'
import styles from './DateStyles.module.css'

const DatePickerPerFlag = (
  datePickerProps: Omit<
    DatePickerProps,
    | 'date'
    | 'onDateChange'
    | 'focused'
    | 'onFocusChange'
    | 'renderMonthText'
    | 'renderMonthElement'
  > & {
    value?: moment.Moment | null | undefined
    onChange?: (date: moment.Moment | null, dateString: string) => void
    date?: moment.Moment | null | undefined
    onDateChange?: (date: moment.Moment | null) => void
  }
) => {
  const { date, value, onChange, onDateChange, ...rest } = datePickerProps
  const currentDate = value !== undefined ? value : date ?? null

  return (
    <div className={styles.container}>
      <DatePicker
        date={currentDate}
        onDateChange={(date) => {
          onDateChange?.(date)
          onChange?.(date, '')
        }}
        renderNavNextButton={renderNavNextButton}
        renderNavPrevButton={renderNavPrevButton}
        customInputIcon={renderCustomInputIcon(datePickerProps.disabled)}
        customCloseIcon={renderCustomCloseIcon()}
        {...rest}
      />
    </div>
  )
}

export default DatePickerPerFlag

export type { DatePickerProps }
